import { render, staticRenderFns } from "./StartGrids.vue?vue&type=template&id=33ea76dd&"
import script from "./StartGrids.vue?vue&type=script&lang=js&"
export * from "./StartGrids.vue?vue&type=script&lang=js&"
import style0 from "./StartGrids.vue?vue&type=style&index=0&id=33ea76dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports